import type { GetApiV1ThreeLetterCodePartnerAdminsGroups200 } from '@fukuri-admins/apis/client/gen/model';
import type { EditClientPresentation } from '../../presentations';

type GroupOption = React.ComponentProps<typeof EditClientPresentation>['groupOptions'][number];

type IConvertToGroupOptions = (
  groups: GetApiV1ThreeLetterCodePartnerAdminsGroups200
) => GroupOption[];

/**
 * グループAPIレスポンスをグループ選択肢に変換する
 */
export const convertToGroupOptions: IConvertToGroupOptions = groups =>
  groups.groups.map(({ id, name, code }) => ({
    id: String(id),
    name,
    code,
  }));
